import React, { ReactNode } from 'react';
import { Logger, LoggerContext } from '@cko/dashboard-shared';

import { getFallbackLogger } from './fallbackLogger';

type Props = {
  children: ReactNode;
  logger?: Logger;
};

export const LoggerProvider = ({ children, logger }: Props) => {
  const loggerToUse = logger ? logger : getFallbackLogger();

  return <LoggerContext.Provider value={loggerToUse}>{children}</LoggerContext.Provider>;
};
